import React, { Component } from 'react';
import Inherit from '../../../core/inherit';
import AuditorController from './auditor.controller';
import withNavigate from '../../../core/withNavigate';

import { Button } from 'antd';
import { UserCheck, Mail, ClipboardCheck } from 'lucide-react';
import { Layout, PageHeader, StatusTag, TableSkeleton } from '../../common';
import { AuditorStores } from './elements';

class ShelfAuditorProfile extends Inherit(AuditorController, Component) {
    state = { auditor: {}, loading: true, stores: [] };

    render() {
        const { auditor, loading, stores } = this.state;
        return (
            <Layout user={this.user}>
                {loading ? (
                    <TableSkeleton rows={8} columns={4} />
                ) : (
                    <>
                        <PageHeader
                            icon={<UserCheck />}
                            title={auditor?.name}
                            meta={
                                <>
                                    <StatusTag tone="warning">Auditor</StatusTag>
                                    <a
                                        href={`mailto:${auditor?.email}`}
                                        className="inline-flex items-center gap-1.5 text-sm text-surface-600 hover:text-primary-600 transition-colors">
                                        <Mail className="text-surface-400 text-[13px]" />
                                        {auditor?.email}
                                    </a>
                                </>
                            }
                            actions={
                                <Button icon={<ClipboardCheck />} onClick={() => this.openInAuditConsole()}>
                                    Ver en consola de auditoría
                                </Button>
                            }
                        />
                        <AuditorStores stores={stores} auditorId={auditor?._id} updateStores={this.updateStores.bind(this)} />
                    </>
                )}
            </Layout>
        );
    }
}

export default withNavigate(ShelfAuditorProfile);
